export default function Hero() {
  const handleNavClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[680px] flex items-center bg-background-50 overflow-hidden"
    >
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-0 right-0 w-[600px] h-[600px] rounded-full bg-primary-100/40 blur-3xl"></div>
        <div className="absolute bottom-0 left-0 w-[400px] h-[400px] rounded-full bg-accent-100/30 blur-3xl"></div>
      </div>

      <div className="relative w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16 pt-24 pb-16 md:pt-20 md:pb-20">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-5">
              <span className="w-1.5 h-1.5 rounded-full bg-primary-500 animate-pulse"></span>
              实时更新 · 高清流畅
            </div>

            <h1 className="font-heading text-[28px] md:text-[40px] lg:text-[46px] font-black text-foreground-950 leading-tight mb-4">
              吃瓜视频在线观看
              <span className="block text-primary-600 text-[22px] md:text-[30px] lg:text-[34px] font-bold mt-1">
                51吃瓜 · 91吃瓜 · 黑料吃瓜 一站式点播平台
              </span>
            </h1>

            <p className="text-foreground-600 text-sm md:text-base leading-relaxed max-w-[600px] mx-auto lg:mx-0 mb-7">
              全网热门吃瓜视频在线观看平台，汇聚51吃瓜、91吃瓜、黑料吃瓜等热门内容源。
              每日更新最新娱乐八卦、社会热点、网红黑料，高清视频即点即看，无需下载，
              流畅播放体验让你随时随地在线吃瓜。当前覆盖热门事件跟踪、独家爆料汇总、
              深度扒皮分析等多维度内容，紧跟吃瓜圈最新动态。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-5 md:gap-8 mb-8">
              <div className="text-center">
                <div className="font-heading text-2xl md:text-3xl font-bold text-primary-600">10,000+</div>
                <div className="text-xs md:text-sm text-foreground-500 mt-0.5">高清视频资源</div>
              </div>
              <div className="w-px h-10 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="font-heading text-2xl md:text-3xl font-bold text-accent-600">每日更新</div>
                <div className="text-xs md:text-sm text-foreground-500 mt-0.5">365天不间断</div>
              </div>
              <div className="w-px h-10 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="font-heading text-2xl md:text-3xl font-bold text-secondary-600">流畅高清</div>
                <div className="text-xs md:text-sm text-foreground-500 mt-0.5">即点即看无卡顿</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#ranking"
                onClick={(e) => { e.preventDefault(); handleNavClick('#ranking'); }}
                className="whitespace-nowrap inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-colors cursor-pointer"
              >
                立即吃瓜
                <i className="ri-arrow-right-line"></i>
              </a>
              <a
                href="#topics"
                onClick={(e) => { e.preventDefault(); handleNavClick('#topics'); }}
                className="whitespace-nowrap inline-flex items-center gap-2 px-7 py-3.5 rounded-full border-2 border-background-300 text-foreground-700 font-semibold text-sm hover:border-primary-300 hover:text-primary-600 transition-colors cursor-pointer"
              >
                浏览话题
                <i className="ri-hashtag"></i>
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[500px] lg:max-w-none">
            <div className="relative">
              <div className="w-full aspect-[4/3] rounded-2xl overflow-hidden bg-background-100">
                <img
                  src="https://readdy.ai/api/search-image?query=Stylized%20abstract%20entertainment%20media%20collage%20with%20warm%20coral%20and%20amber%20tones%2C%20geometric%20shapes%20and%20playful%20patterns%2C%20modern%20editorial%20design%20with%20bold%20graphic%20elements%2C%20video%20play%20button%20motifs%20integrated%20into%20abstract%20composition%2C%20clean%20minimal%20background%20with%20vibrant%20accents%2C%20sophisticated%20pop%20culture%20aesthetic&width=800&height=600&seq=hero-visual-2026-01&orientation=landscape"
                  alt="吃瓜视频在线观看 - 热门娱乐八卦视频一站式平台"
                  className="w-full h-full object-cover object-top"
                  onError={(e) => { const el = e.currentTarget.parentElement; if (el) el.style.display = 'none'; }}
                />
              </div>
              <div className="absolute -bottom-4 -left-4 bg-background-50 rounded-xl px-4 py-3 border border-background-200/70 hidden md:flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center">
                  <i className="ri-fire-line text-primary-600 text-lg"></i>
                </div>
                <div>
                  <div className="text-xs text-foreground-500">今日更新</div>
                  <div className="font-bold text-foreground-900 text-sm">128条新瓜</div>
                </div>
              </div>
              <div className="absolute -top-3 -right-3 bg-accent-500 text-background-50 rounded-full w-14 h-14 flex items-center justify-center hidden md:flex">
                <i className="ri-play-fill text-2xl"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}